import { useCurrentProStoragePlan } from "hooks/show/paidFeatures";
import { useMemo } from "react";
import getShowFileUploadLimit from "tools/file/getShowFileUploadLimit";

export const useFileUploadSizeLimit = (sizeLimit?: number) => {
  const [currentPlan, isLoading] = useCurrentProStoragePlan();

  return useMemo(() => {
    if (isLoading) {
      return null;
    }
    const limit = getShowFileUploadLimit(currentPlan);
    if (!sizeLimit || isNaN(sizeLimit)) {
      return limit;
    }
    return sizeLimit;
  }, [currentPlan, sizeLimit, isLoading]);
};
